/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M736 960.8V736.1h84.2V511.5H539.5v224.6h84.2v224.6H399.1V736.1h84.2V511.5H202.5v224.6h84.2v224.6H62.1V736.1h84.2V455.3h337V286.9h-84.2V62.2h224.6v224.6h-84.2v168.5h337v280.8h84.2v224.6H736zM118.3 792.3v112.3h112.3V792.3H118.3zm449.2-561.6V118.4H455.2v112.3h112.3zM455.2 792.3v112.3h112.3V792.3H455.2zm449.3 0H792.2v112.3h112.3V792.3z" _fill="#111"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/organization.js